import React from "react";
import type {
  UseFormReturn,
  FieldValues,
  SubmitHandler,
} from "react-hook-form";
import { FormProvider } from "react-hook-form";
import cn from "classnames";
import styles from "./Form.module.scss";

interface FormProps<T extends FieldValues> {
  formMethods: UseFormReturn<T>;
  onSubmit: SubmitHandler<T>;
  children: React.ReactNode;
  className?: string;
  id?: string;
  /** Additional attributes */
  [key: string]: unknown;
}

/**
 * Form component using react-hook-form
 *
 * This component serves as the main container for form elements,
 * managing form state and validation through react-hook-form.
 */
const Form = <T extends FieldValues>({
  formMethods,
  onSubmit,
  children,
  className,
  id,
  ...rest
}: FormProps<T>) => {
  return (
    <FormProvider {...formMethods}>
      <form
        id={id}
        onSubmit={formMethods.handleSubmit(onSubmit)}
        className={cn(styles.form, className)}
        {...rest}
      >
        {children}
      </form>
    </FormProvider>
  );
};

export default Form;
